/** @jsx jsx */
import { useState } from 'react'
import { Box, Flex, jsx, Spinner } from 'theme-ui'
import { useGiftCards } from '~/hooks/components/use-gift-cards'
import LineItemGiftCard from './GiftCard'

const LineItemGiftCards = ({ giftCards, lineItemId, orderConfirmed }) => {
  const { removeGiftCardFromCart } = useGiftCards()
  const [isLoading, setIsLoading] = useState(false)

  const handleRemoveGiftCard = async (giftCardId) => {
    setIsLoading(true)
    await removeGiftCardFromCart(lineItemId, giftCardId)
    setIsLoading(false)
  }

  return (
    <Box sx={{ position: 'relative' }}>
      {isLoading && (
        <Flex
          sx={{
            alignItems: 'center',
            bottom: '0',
            justifyContent: 'center',
            left: '0',
            position: 'absolute',
            right: '0',
            top: '0',
          }}
        >
          <Spinner
            color="brandTertiary"
            size="40"
            sx={{
              '@media (prefers-reduced-motion)': {
                circle: {
                  animationIterationCount: 8,
                },
              },
            }}
          />
        </Flex>
      )}
      {giftCards.map((giftCard) => (
        <Box
          key={`gift-card-li-${giftCard.id}`}
          mt={1}
          mb={2}
          sx={{ opacity: !isLoading ? '1' : '0.1' }}
        >
          <LineItemGiftCard
            giftCard={giftCard}
            handleRemove={handleRemoveGiftCard}
            orderConfirmed={orderConfirmed}
            setIsLoading={setIsLoading}
          />
        </Box>
      ))}
    </Box>
  )
}

export default LineItemGiftCards
